export class SendCompareExportMail {

  constructor(
    public jobId?: number,
    public recipients?: string[]
  ) {
  }
}
